export const ALL_IN_ONE_CHAT_PAGE_ID = [
  '116388304732570', //Test TTB,
  '421936097949882', // prod TTB
  '134792133058142' // test prod
]

export const ALL_IN_ONE_CHAT_THEME_LIST = [
  'universalutilities',
  'qualityexpress',
  'scgworkplace',
  'hafele',
  'scgallrent',
  'erawon',
  'nvbb',
  'ticket',
  'toa',
  'tero',
  'ceemeagain',
  'runkan',
  'ticket2',
  'studio7',
  'mjd',
  'tdtawandang',
  'ustore',
  'toaecoupon',
  'kingkitchen',
  'oab',
  'foodguru',
  'webchat',
  'secap',
  'cityfresh',
  'summitcapital',
  'tisco',
  'scgdistribution',
  'ttb'
]



// WEBPACK FOOTER //
// ./src/constants/all-in-one-chat.js